import React from 'react';
import { connect } from 'react-redux';

import classes from './AddonsHeader.scss';

import AddonHeading from '../AddonsTypography/AddonHeading/AddonHeading';
import AddonsSubHeading from '../AddonsTypography/AddonSubHeading/AddonSubHeading';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as uiActions from '../../../store/actions/index';

const addonsHeader = (props) => {
    return (
        <div className={`u-flex justify-content-between align-items-center u-backgroundColorWhite`}>
            {
                props.isSeats ? 
                <div className={`${[classes.Box, props.view === 'seats' ? classes.BoxActive : null].join(' ')} f-1 u-borderRightNormal u-cursorPointer`}>
                    <a className={`u-block u-flex f-column justify-content-center align-items-center pt-5 pb-4 `} onClick={() => props.onToggleAddons('seats')}>
                        <AddonHeading active={props.view === 'seats' ? true : false}>Seats</AddonHeading>
                        {
                            props.view === 'seats' ? <span onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                props.onAddonsExpanded();
                            }} className={`u-textColorPrimary u-fontWeightMedium u-cursorPointer u-textTransformUppercase`}>
                                <span className={`mr-1`}>
                                <FontAwesomeIcon icon="times" color="#666" size="sm" className={`u-textColorPrimary`} /></span>Close</span> : 
                                <AddonsSubHeading>Choose your seat</AddonsSubHeading>
                        }
                    </a>
                </div> : null
            }
            {
                props.isBaggages ? 
                <div className={`${[classes.Box, props.view === 'baggage' ? classes.BoxActive : null].join(' ')} f-1 u-borderRightNormal u-cursorPointer`}>
                    <a className={`u-block u-flex f-column justify-content-center align-items-center pt-5 pb-4 `} onClick={() => props.onToggleAddons('baggage')}>
                        <AddonHeading active={props.view === 'baggage' ? true : false}>Baggage</AddonHeading>
                        {
                            props.view === 'baggage' ? <span onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                props.onAddonsExpanded();
                            }} className={`u-textColorPrimary u-fontWeightMedium u-cursorPointer u-textTransformUppercase`}>
                                <span className={`mr-1`}>
                                    <FontAwesomeIcon icon="times" color="#666" size="sm" className={`u-textColorPrimary`} /></span>Close</span> : 
                                    <AddonsSubHeading>Add extra luggage</AddonsSubHeading>
                        }
                    </a>
                </div> : null
            }
            {
                props.isMeals ? 
                <div className={`${[classes.Box, props.view === 'meals' ? classes.BoxActive : null].join(' ')} f-1 u-cursorPointer`}>
                    <a className={`u-block u-flex f-column justify-content-center align-items-center pt-5 pb-4 `} onClick={() => props.onToggleAddons('meals')}>
                        <AddonHeading active={props.view === 'meals' ? true : false}>Meals</AddonHeading>
                        {
                            props.view === 'meals' ? <span onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                props.onAddonsExpanded();
                            }} className={`u-textColorPrimary u-fontWeightMedium u-cursorPointer u-textTransformUppercase`}>
                                <span className={`mr-1`}>
                                    <FontAwesomeIcon icon="times" color="#666" size="sm" className={`u-textColorPrimary`} /></span>Close</span> :
                                    <AddonsSubHeading>Select your meal</AddonsSubHeading> 
                        }
                    </a>
                </div> : null
            }
        </div>
    );
}

const mapStateToProps = state => {
    return {
        view: state.ui.addonsView,
        isMeals: state.farePrice.generalData && state.farePrice.generalData.data.meals && JSON.parse(state.farePrice.generalData.data.meals.isMeal) === true,
        isBaggages: state.farePrice.generalData && state.farePrice.generalData.data.baggage && JSON.parse(state.farePrice.generalData.data.baggage.isbaggage) === true,
        isSeats: state.farePrice.generalData && state.farePrice.generalData.data.seats
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onToggleAddons: (view) => dispatch(uiActions.toggleAddons(view)),
        onAddonsExpanded: () => dispatch(uiActions.addonsExpanded())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(addonsHeader);


// WEBPACK FOOTER //
// ./src/components/Addons/AddonsHeader/AddonsHeader.js